import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import {
  formatReferrer,
  formatVisitCount,
  type SiteVisitPath,
  type SiteVisitReferrer,
} from '../../types/siteVisits';

type Row = { key: string; label: string; views: number };

function RankedTable({ title, header, rows, emptyText }: { title: string; header: string; rows: Row[]; emptyText: string }) {
  const maxViews = Math.max(1, ...rows.map((row) => row.views));
  return (
    <section className="rounded-xl border bg-card shadow" aria-label={title}>
      <h3 className="px-4 pt-4 text-sm font-semibold">{title}</h3>
      {rows.length === 0 ? (
        <p className="px-4 py-8 text-center text-sm text-muted-foreground">{emptyText}</p>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-10">#</TableHead>
              <TableHead>{header}</TableHead>
              <TableHead className="w-28 text-right">조회수</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.key}>
                <TableCell className="text-muted-foreground">{index + 1}</TableCell>
                <TableCell className="relative min-w-0">
                  <span
                    className="absolute inset-y-1 left-0 rounded-r bg-primary/10"
                    style={{ width: `${Math.round((row.views / maxViews) * 100)}%` }}
                    aria-hidden
                  />
                  <span className="relative block max-w-[60vw] truncate font-mono text-xs sm:max-w-none sm:text-sm" title={row.label}>{row.label}</span>
                </TableCell>
                <TableCell className="text-right tabular-nums">{formatVisitCount(row.views)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </section>
  );
}

export function VisitsTopTables({ paths, referrers }: { paths: SiteVisitPath[]; referrers: SiteVisitReferrer[] }) {
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <RankedTable
        title="상위 경로"
        header="경로"
        emptyText="집계된 경로가 없습니다."
        rows={paths.map((item) => ({ key: item.path, label: item.path || '/', views: item.views }))}
      />
      <RankedTable
        title="상위 유입"
        header="유입 출처"
        emptyText="집계된 유입 출처가 없습니다."
        rows={referrers.map((item) => ({ key: item.referrer || '(direct)', label: formatReferrer(item.referrer), views: item.views }))}
      />
    </div>
  );
}
